var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.invoiceList),function(item,index){return _c('div',{key:index,style:({ color: _vm.getFieldColor(item.bill_type) })},[_vm._v("\n    "+_vm._s(_vm.getFieldValue(item))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }